import React, { useRef } from "react";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import "./shareModal.css";
import blogIcons from "../../blogIcon";
import CopyLinkContainer from './../../../../Utility/copyURL';
import { handleURLCopy } from "../../../../Utility/utils";

const ShareModal = ({ isOpen, closeModal, blogTitle, blogSummary,URL, setCopyURL, copyURL }) => {
    
    const modalRef = useRef();

    const handleCloseModal = (e) => {
        if (e.target === modalRef.current) {
        closeModal();
        }
    };

    if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" ref={modalRef} onClick={handleCloseModal}>
      <div className="custom-modal">
        <div className="modal-heading">
            <h3>Choose platform to share this blog</h3>
            <button className="btn-close" onClick={closeModal}>
                <span>&times;</span>
            </button>
        </div>
        <div className="modal-content">
          <div className="blog-share-icon">
            <FacebookShareButton 
                url={URL} 
                quote={blogTitle}
                summary={blogSummary}
            >
                <div className="facebook-icon">
                    {blogIcons.facebook}
                </div>
            </FacebookShareButton>
          </div>
          <div className="blog-share-icon">
            <TwitterShareButton 
                url={URL} 
                title={blogTitle}
                summary={blogSummary}
            >
              <div className="twitter-icon">
                {blogIcons.twitter}
              </div>
            </TwitterShareButton>
          </div>
          <div className="blog-share-icon">
            <LinkedinShareButton 
                url={URL} 
                title={blogTitle} 
                summary={blogSummary}
            >
                <div className="linkedin-icon">
                    {blogIcons.linkedin}
                </div>
            </LinkedinShareButton>
          </div>
        </div>
          <CopyLinkContainer 
            URL={URL}
            handleURLCopy={() => handleURLCopy(URL, setCopyURL)}
            copyURL={copyURL}
          />
      </div>
    </div>
  );
};

export default ShareModal;
